import Loadable from 'react-loadable';
import Loading from '../components/Loading/LoadingPage';

const asyncHome = Loadable({
  loader: () => import('../pages/homepage/home.js'),
  loading: Loading,
  delay: 500,
});

const asyncNews = Loadable({
  loader: () => import('../pages/news/news.js'),
  loading: Loading,
  delay: 500,
});
const asyncNewsDetail = Loadable({
  loader: () => import('../pages/news/NewsDetails'),
  loading: Loading,
  delay: 500,
});
const asyncContact = Loadable({
  loader: () => import('../pages/contacts/contacts.js'),
  loading: Loading,
  delay: 500,
});
const asyncPublications = Loadable({
  loader: () => import('../pages/publications/publications.js'),
  loading: Loading,
  delay: 500,
});
const asyncMembers = Loadable({
  loader: () => import('../pages/members/members.js'),
  loading: Loading,
  delay: 500,
});
const asyncManagement = Loadable({
  loader: () => import('../pages/management/management.js'),
  loading: Loading,
  delay: 500,
});

const asyncBroadcasting = Loadable({
  loader: () => import('../pages/broadcasting/broadcasting.js'),
  loading: Loading,
  delay: 500,
});

const asyncBroadcastingDetails = Loadable({
  loader: () => import('../pages/broadcasting/BroadcastDetails'),
  loading: Loading,
  delay: 500,
});

const asyncAbout = Loadable({
  loader: () => import('../pages/about/about.js'),
  loading: Loading,
  delay: 500,
});

const asyncEvents = Loadable({
  loader: () => import('../pages/events/events.js'),
  loading: Loading,
  delay: 500,
});

const asyncEventsDetails = Loadable({
  loader: () => import('../pages/events/EventDetails'),
  loading: Loading,
  delay: 500,
});

const asyncEventRegister = Loadable({
  loader: () => import('../pages/events/EventRegister'),
  loading: Loading,
  delay: 500,
});

const asyncLinks = Loadable({
  loader: () => import('../pages/links/links.js'),
  loading: Loading,
  delay: 500,
});

const asyncCPD = Loadable({
  loader: () => import('../pages/dynamic/cpd.js'),
  loading: Loading,
  delay: 500,
});

const asyncRRN = Loadable({
  loader: () => import('../pages/dynamic/rrn.js'),
  loading: Loading,
  delay: 500,
});

const asyncEducation = Loadable({
  loader: () => import('../pages/dynamic/education.js'),
  loading: Loading,
  delay: 500,
});

const asyncTerms = Loadable({
  loader: () => import('../pages/dynamic/terms.js'),
  loading: Loading,
  delay: 500,
});

const asyncSearch = Loadable({
  loader: () => import('../pages/search/search.js'),
  loading: Loading,
  delay: 500,
});

const asyncEducationalWing = Loadable({
  loader: () => import('../pages/dynamic/educational_wing.js'),
  loading: Loading,
  delay: 500,
});

const asyncWebinars = Loadable({
  loader: () => import('../pages/webinars/Webinars.js'),
  loading: Loading,
  delay: 500,
});

const asyncWebinarDetail = Loadable({
  loader: () => import('../pages/webinars/WebinarDetail.js'),
  loading: Loading,
  delay: 500,
});

const asyncWebinarsContent = Loadable({
  loader: () => import('../pages/dynamic/webinar_content.js'),
  loading: Loading,
  delay: 500,
});

const asyncWebinarRecordings = Loadable({
  loader: () => import('../pages/dynamic/webinar_recordings.js'),
  loading: Loading,
  delay: 500,
});

const asyncCookies = Loadable({
  loader: () => import('../pages/dynamic/cookies.js'),
  loading: Loading,
  delay: 500,
});

export default [
  {
    path: '/',
    component: asyncHome,
    authenticated: false,
  },
  {
    path: '/news',
    component: asyncNews,
    authenticated: false,
  },
  {
    path: '/news/:id',
    component: asyncNewsDetail,
    authenticated: false,
  },
  {
    path: '/contact',
    component: asyncContact,
    authenticated: false,
  },
  {
    path: '/publications',
    component: asyncPublications,
    authenticated: false,
  },
  {
    path: '/members',
    component: asyncMembers,
    authenticated: false,
  },
  {
    path: '/management',
    component: asyncManagement,
    authenticated: false,
  },
  {
    path: '/broadcast',
    component: asyncBroadcasting,
    authenticated: false,
  },
  {
    path: '/broadcast/:id',
    component: asyncBroadcastingDetails,
    authenticated: false,
  },
  {
    path: '/about',
    component: asyncAbout,
    authenticated: false,
  },
  {
    path: '/events',
    component: asyncEvents,
    authenticated: false,
  },
  {
    path: '/events/:id',
    component: asyncEventsDetails,
    authenticated: false,
  },
  {
    path: '/events/:id/register',
    component: asyncEventRegister,
    authenticated: false,
  },
  {
    path: '/links',
    component: asyncLinks,
    authenticated: false,
  },
  {
    path: '/cpd',
    component: asyncCPD,
    authenticated: false,
  },
  {
    path: '/rrn',
    component: asyncRRN,
    authenticated: false,
  },
  {
    path: '/education',
    component: asyncEducation,
    authenticated: false,
  },
  {
    path: '/terms',
    component: asyncTerms,
    authenticated: false,
  },
  {
    path: '/search',
    component: asyncSearch,
    authenticated: false,
  },
  {
    path: '/educational-wing',
    component: asyncEducationalWing,
    authenticated: false,
  },
  {
    path: '/webinars',
    component: asyncWebinars,
    authenticated: false,
  },
  {
    path: '/webinars/:id',
    component: asyncWebinarDetail,
    authenticated: false,
  },
  {
    path: '/webinar-content',
    component: asyncWebinarsContent,
    authenticated: false,
  },
  {
    path: '/webinar-recordings',
    component: asyncWebinarRecordings,
    authenticated: false,
  },
  {
    path: '/cookies',
    component: asyncCookies,
    authenticated: false,
  }
];



// WEBPACK FOOTER //
// ./src/routes/UnauthenticatedRoutes.js